// FB 14847
import React, {
    useEffect, useContext, useState, useCallback
} from 'react';
import _ from 'lodash';
import { MetadataContent } from '@jutro/uiconfig';
import { withRouter } from 'react-router-dom';
import { withAuthenticationContext, useAuthentication, AUTH_ERRORS } from 'gw-digital-auth-react';

import { TranslatorContext, IntlContext } from '@jutro/locale';
import { RIFormsListComponent, RIFormsOrderComponent } from 'gw-capability-policy-common-react';
import { PolicyService } from 'gw-capability-policy';
import { UserService } from 'gw-capability-ri-policy';
import styles from './RIFormsOrderingPage.module.scss';
import metadata from './RIFormsOrderingPage.metadata.json5';
import messages from './RIFormsOrderingPage.messages';

function RIFormsOrderingPage() {
    const translator = useContext(TranslatorContext);
    const { authHeader } = useAuthentication();

    const [currentView, setCurrentView] = useState('Step1');
    const [activeIndex, setActiveIndex] = useState(0);
    const [stepsObj, setSteps] = useState([
        { onClick: () => clickStep(0), title: 'Select Form', disabled: false },
        { onClick: () => clickStep(1), title: 'Process Order', disabled: true },
        { onClick: () => clickStep(2), title: 'Order Placed', disabled: true }
    ]);
    const stepLabels = ['Step1', 'Step2', 'Step3'];

    const [selectedItems, setSelectedItems] = useState([]);
    const [formsFullList, setFormsFullList] = useState([]);
    const [userInfo, setUserInfo] = useState({});
    const [pageError, updatePageError] = useState();
    const [isLoading, setLoadingState] = useState(false);

    useEffect(() => {
        setLoadingState(true);
        getUserInfo();
        getForms();
    }, []);

    useEffect(() => {
        setActiveStep(activeIndex);
    }, [activeIndex]);

    const getUserInfo = () => {
        UserService.getPolicyHolderFormsOrderRequestForCurrentUser_RI(authHeader).then(
		   (response = {}) => {
			   if (!_.isUndefined(response)) {
				   setUserInfo(response);
			   }
		   }
        ).catch((err) => {
			   updatePageError('errorLoadingformsOrdering');
		   }).finally(() => {
            //    setLoadingState(false);
		   });
    };

    const getForms = async () => {
        await PolicyService.getAvailableRIResourcesForCurrentUser_Ext(authHeader).then(
            (response = {}) => {
                if (!_.isUndefined(response)) {
                    
                    const formsFullList = getFormsListTable(filterByCategory(response));
                    setFormsFullList(formsFullList);
                }
            }
        ).catch((err) => {
            updatePageError('errorLoadingformsOrdering');
        }).finally(() => {
            setLoadingState(false);
        });
    };

    const clickNext = useCallback((selectedItems) => {
        setSelectedItems(selectedItems);
        setActiveIndex((i) => i + 1);
        enableStep(activeIndex + 1);
    }, [activeIndex]);

    const clickPrevious = useCallback(() => {
        setActiveIndex((i) => i - 1);
    }, [activeIndex]);

    const cancelOrder = useCallback(() => {
        selectedItems.forEach((item) => {
            // Clear the quantity in the original form list
            _.forEach(formsFullList, (form) => {
                if (item.resourceName === form.resourceName && item.state === form.state) {
                    form.quantity = '';
                }
            });
        });

        setSelectedItems([]);
        // console.log(`a1 activeIndex = ${activeIndex}`);
        disableStep(activeIndex);
        setActiveIndex((i) => i - 1);
        clearVisitedStep(1);
        clearVisitedStep(2);
    }, [activeIndex]);

    const clickStep = (i) => {
        if (!stepsObj[i].disabled) {
            setActiveIndex(i);
        }
    };

    const enableStep = (i) => {
        stepsObj[i].disabled = false;
    };

    const disableStep = (i) => {
        stepsObj[i].disabled = true;
    };

    const clearVisitedStep = (i) => {
        stepsObj[i].visited = false;
    };

    const setActiveStep = (i) => {
        _.forEach(stepsObj, (step, j) => {
            if (j === i) {
                step.active = true;
                step.visited = true;
            } else {
                step.active = false;
            }
        });

        setCurrentView(stepLabels[i]);
        setSteps(stepsObj);
    };

    const filterByCategory = (formsList) => {
        const filteredList = _.filter(formsList, (form) => {
            return !_.isUndefined(form.category);
        });
        return filteredList;
    };

    const getFormsListTable = (formsList) => {
        let formsListArrayResult = [];
        formsListArrayResult = formsList.map((data) => {
            const objData = {
                quantity: '',
                category: data.category,
                resourceName: data.resourceName,
                state: data.state,
                resourceDesc: data.resourceDesc,
                language: data.language,
                priority: data.priority,
                docUID: data.docUID,
                docSessionID: data.docSessionID
            };
            return objData;
        });
        return formsListArrayResult;
    };

    const orderPlaced = () => {
        setActiveIndex((i) => i + 1);
        disableStep(0);
        disableStep(1);
    };

    const processingOrder = (isProcessing) => {
        if (isProcessing) {
            disableStep(0);
            disableStep(1);
        } else {
            enableStep(0);
            enableStep(1);
        }
    };

    const startOver = () => {
        cancelOrder();
        // Back to setp 1
        setActiveIndex((i) => i - 1);
        disableStep(1);
        enableStep(0);
        clearVisitedStep(1);
        clearVisitedStep(2);
    };

    const overrides = {
        progressBar: {
            steps: stepsObj,
            visible: !isLoading,
        },
        formsOrderingLoader: {
            loaded: !isLoading
        },
        errorMsg: {
            visible: !_.isUndefined(pageError),
            content: translator(messages[pageError])
        },
        formsListing: {
            visible: currentView == 'Step1' && !isLoading,
            capability: [clickNext, clickPrevious, disableStep, clearVisitedStep],
            formsFullList: formsFullList,
            selectedItemsBack: selectedItems
        },
        formsOrder: {
            visible: currentView == 'Step2',
            capability: [clickNext, clickPrevious, cancelOrder, orderPlaced, processingOrder],
            selectedItems: selectedItems,
            authHeader: authHeader,
            userInfo: userInfo
        },
        orderPlacedContainer: {
            visible: currentView == 'Step3'
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            clickNext,
            clickPrevious,
            cancelOrder,
            orderPlaced,
            startOver,
            processingOrder
        },
        resolveComponentMap: {
            formsListComponent: RIFormsListComponent,
            formsOrderComponent: RIFormsOrderComponent
        }
    };

    // return renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            {...resolvers}
        />
    );
}

export default withRouter(withAuthenticationContext(RIFormsOrderingPage));
